/**
 * The type scale every control of a screen toolbar types at -- search fields and filter triggers
 * alike -- so that a toolbar reads as one row rather than three sizes.
 *
 * It has to be named because the library's `md` step, the 40px height these controls share, does
 * not carry one scale: a search bar reads that token as `text-lg` and a select reads it as
 * `text-md`, both above the text the row sits in. Naming the scale settles it without shrinking
 * the fields themselves, which keep their height.
 */
export const TOOLBAR_CONTROL_TEXT_SIZE = 'sm' as const;
